import { render, staticRenderFns } from "./sayfaEkle.vue?vue&type=template&id=08b0c45c&scoped=true"
import script from "./sayfaEkle.vue?vue&type=script&lang=js"
export * from "./sayfaEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0c45c",
  null
  
)

export default component.exports